import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class SaverProvider {

  constructor(public gateway: GatewayClientProvider) {

  }

  addSaverConnection(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addSaverConnection(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  removeSaverConnection(connection) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.removeSaverConnection(connection)
        .then(() => {
          resolve(true);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getSaverTransactions() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getSaverTransaction()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  addConnectionRules(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addConnectionRules(data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getSweeperConnectionRules() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getSweeperConnectionRules()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getConnectionTransaction(account_number) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getConnectionTransaction(account_number)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getSavingRuleByConnection(connection) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getSavingRuleByConnection(connection)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  deleteSweeperData(Sweep) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.removeSweeper(Sweep)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/saver/saver.ts